
import { User } from '../../providers/user';
import { Component } from '@angular/core';
import { AlertController } from 'ionic-angular';

/*
  Generated class for the AccountLoginSocial component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-login-social',
  templateUrl: 'account-login-social.html'
})
export class AccountLoginSocialComponent {

  text: string;

  constructor(
    public user: User,
    public alert: AlertController) { }
  /**
   * onLogin
   * test only in device
   * 
   * @param {any} provider - current options: facebook, google
   */
  onLogin(provider) {
    switch (provider) {
      //
      // Google Login
      //
      case 'google':
        this.user.authWithGoogle((authData) => {
          console.log('authData: '+ authData);
          let googleProviderCredential = this.user.fb.auth.GoogleAuthProvider.credential(authData.idToken, authData.accessToken);
          this.doLogin(googleProviderCredential);
          //
          // @todo bug
          // firebase is replacing password
          // when we already has an account manually created
          // to workaround this behavior we have to double check with fetchProvidersForEmail
          //
          // this.user.fb.auth().fetchProvidersForEmail(authData.email).then((list) => {
          //   var hasPassword = list.find((item) => { return item === 'password'; });
          //   // let hasGoogle = list.find((item) => { return item === 'google.com'; });
          //   var hasFacebook = list.find((item) => { return item === 'facebook.com'; });
          //
          //   // if has only password or password and facebook
          //   if ((list.length === 1 && hasPassword) || (list.length === 2 && hasPassword && hasFacebook)) {
          //     setTimeout(() => {
          //       this.loginError({ code: 'auth/account-exists-with-different-credential' });
          //     }, 0);
          //   } else {
          //     return this.doLogin(provider);
          //   }
          // }, (error) => {
          //   setTimeout(() => {
          //     this.loginError(error);
          //   }, 0);
          // });
        }, (error) => {
          console.error('error auth with google: ');
          console.error(error);
          alert(error)
        });
        break;
      //
      // Facebook Login
      //
      case 'facebook':
        this.user.authWithFacebook((token) => {
          let facebookProviderCredential = this.user.fb.auth.FacebookAuthProvider.credential(token);
          this.doLogin(facebookProviderCredential);
        }, (error) => {
          console.error('error auth with fb: ');
          console.error(error);
        });
        break;
    }
  }

  /**
   * Do Login
   * 
   * @param {any} provider
   * @returns
   * 
   * @memberOf AccountLoginSocial
   */
  doLogin(provider) {
    return this.user.fb.auth().signInWithCredential(provider).then((success) => {
      // we dont have to do nothing because there are already an event for when user is logged
      console.debug(success);
    }, (error) => {
      console.error('error sign in with credential: ');
      console.error(error);
      this.errorHandler(error);
    });
  }

  errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    let alert = this.alert.create({
      title: handler.title,
      subTitle: handler.message,
      buttons: ['OK']
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/components/account-login-social/account-login-social.ts